import axios from 'axios';
import type {AxiosResponse} from 'axios';
import cardsTemplate from './templates/tenders-item.twig';
import {Utils} from '@/common/scripts/utils';

const CLASS_ACTIVE = 'is-active';

class Tenders {
    private wrapper: HTMLElement;
    private listWrapper: HTMLElement;
    private moreButton: HTMLElement;
    private action: string;
    private showCount: number = 8;
    private visibleCount: number = 0;
    private items: HTMLElement[];

    init(wrapper: HTMLElement): void {
        this.wrapper = wrapper;

        this.setElements();
        this.fetchTenders();
        this.bindEvents();
    }

    private setElements(): void {
        if (!this.wrapper) {
            return;
        }

        this.listWrapper = this.wrapper.querySelector('.j-tenders__list') as HTMLElement;
        this.moreButton = this.wrapper.querySelector('.j-tenders__more') as HTMLElement;
        this.action = this.wrapper.dataset['action'] || '';
        this.showCount = Number(this.wrapper.dataset['show']) || 8;
    }

    private fetchTenders(): void {
        axios.get(this.action)
            .then((response: AxiosResponse) => {
                const status = response.data.success;
                const items = response.data?.data?.items || [];

                if (status) {
                    this.insertList(items);
                    this.initVisibleItems();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err: unknown) => {
                // this.showError();
                console.error(err);
            });
    }

    private bindEvents(): void {
        if (this.moreButton) {
            this.moreButton.addEventListener('click', () => {
                this.showMore();
            });
        }
    }

    private insertList(items: any[]): void {
        Utils.insetContent(this.listWrapper, cardsTemplate({items}));

        this.items = [...this.listWrapper.querySelectorAll('.j-tenders__item')] as HTMLElement[];
    }

    private initVisibleItems(): void {
        if (!this.items?.length) {
            return;
        }

        this.items.slice(0, this.showCount).forEach((item: HTMLElement) => {
            item.classList.add(CLASS_ACTIVE);
        });

        this.visibleCount = this.showCount;

        this.checkVisibleButtonMore();
    }

    private showMore(): void {
        this.items.slice(this.visibleCount - 1, this.visibleCount + this.showCount).forEach((item: HTMLElement) => {
            item.classList.add(CLASS_ACTIVE);
        });

        this.visibleCount = this.visibleCount + this.showCount;

        this.checkVisibleButtonMore();
    }

    private checkVisibleButtonMore(): void {
        if (this.visibleCount >= this.items.length) {
            this.moreButton.classList.remove(CLASS_ACTIVE);
        } else {
            this.moreButton.classList.add(CLASS_ACTIVE);
        }
    }
}

export default Tenders;
